module.exports = __webpack_public_path__ + "static/media/orange-timer.cedfdeff.png";